export default "__VITE_ASSET__m9pl3Jua__"